import { handleError } from "../helpers/globalHandler";
import { v4 as uuidv4 } from 'uuid';
import Cookies from "cookies-js";
import * as tools from "../helpers/Tools";


export const logAndylitics = (ActivityType, ActivityCode, ActivityStart, ActivityEnd, ActivityJSON, ActivityParam1, ActivityParam2, Url, UserID) => {
    try {
        let correlationId = Cookies.get("bsw-CorrelationId");
        let sessionId = Cookies.get("bsw-SessionId");

        let bswGACookie = Cookies.get("bsw-GACookie");

        let cookieGA = Cookies.get("_ga");
        let cookieGID = Cookies.get("_gid");
        let cookieSCID = Cookies.get("_scid");

        let activityParam2IsJson = false;
        /**ExternalCorrelationId is being passed in from bswhealth.com 
        * setting the externalCorrelationIdSource to bswhealth since it is the only place so far
        * may need to make externalCorrelationIdSource a real parameter or cookie at some point
        * */
        if (doesPathAllowColletionIdOverride()) {
            activityParam2IsJson = true;
            ActivityParam2 = { externalCorrelationId: true, externalCorrelationIdSource: "bswhealth" };
        }
        if (typeof window !== "undefined") {
            if (typeof Url === "undefined" || Url === null || Url === "") {
                Url = window.location.href;
            }
            //const oState = window.store.getState();
            //if (oState && oState.domain) {
            const domain = window.store.getState().domain; // sessionStorage['root'] ? JSON.parse(JSON.parse(sessionStorage['root']).domain) : window.store.getState().domain;
            if (domain) {
                // here we want to keep the correlation id if it was generated from the SSO
                if (typeof correlationId === "undefined" || correlationId === null || correlationId === "") {
                    correlationId = domain.c; //oState.domain.c;
                }
                sessionId = domain.s; //oState.domain.s;
                // fill in userID if it wasn't passed in
                if (typeof UserID === "undefined" || UserID == null || UserID == "") {
                    UserID = domain.un; //oState.domain.un;
                }
            }
        }
        const payload = {
            ActivityType,
            ActivityCode,
            ActivityStart,
            ActivityEnd,
            ActivityDetailsJson: ActivityJSON ? JSON.stringify(ActivityJSON) : null,
            ActivityParam1: ActivityParam1 ? ActivityParam1 : (typeof bswGACookie !== "undefined" && bswGACookie !== null && bswGACookie !== "") ? bswGACookie : ActivityParam1,
            ActivityParam2: activityParam2IsJson ? JSON.stringify(ActivityParam2) : ActivityParam2,
            Url,
            UserName: UserID || window.currentUserName || null,
            ApplicationName: window.serverData.data.andyliticsApplicationName,
            ApplicationVersion: window.serverData.data.applicationVersion,
            Platform: window.serverData.data.browser,
            PlatformVersion: window.serverData.data.browserVersion,
            InstallationIdentifier: window.serverData.data.ipAddress,
            SessionId: sessionId,
            CorrelationId: correlationId,
            IDs: { _ga: cookieGA, _gid: cookieGID, _scid: cookieSCID }
        };

        var fullUrl = window.serverData.data.andyliticsKey; // "/api/Andylitics/Log";
        fullUrl = fullUrl + "&ac=" + ActivityCode;
        //if (typeof correlationId === "undefined" || correlationId === null || correlationId === "") {
        //    debugger;
        //}
        //if (typeof sessionId === "undefined" || sessionId === null || sessionId === "") {
        //    debugger;
        //}
        const params = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
                "bsw-CorrelationId": correlationId,
                "bsw-SessionId": sessionId
            },
            body: JSON.stringify(payload),
            //mode: "no-cors"
        };

        return fetch(fullUrl, params).then(response => {
            try {
                if (handleError(response)) {
                    return Promise.reject(response);
                }
                return response;
            }
            catch (e) {
                console.error(e);
                Promise.reject(response);
            }
        }).then(ret => {
            return ret;
        });
    }
    catch (e) {
        console.error(e);
    }
};
const doesPathAllowColletionIdOverride = () => {
    const isEnabled = window && window.serverData && window.serverData.data.enableDotComSchedulingCorrelationID;
    if (!isEnabled) return false;
    const routeUrl = window.location && window.location.href ? window.location.href.substr(window.location.origin.length) : "";
    const routeParms = routeUrl ? routeUrl.split('/') : [];
    const isEnabledSite = (routeParms.length > 0 && routeParms[1].toLowerCase() === "schedule") || (routeParms.length > 3 && routeParms[3].toLowerCase() === "schedule");
    if (!isEnabledSite) return false;
    const externalCorrelationId = Cookies.get("bsw-ExternalCorrelationId");
    const hasExternalCorrelationId = externalCorrelationId ? externalCorrelationId === "true" : false;
    return hasExternalCorrelationId;
}

export const log = (activityType, activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    logAndylitics(activityType, activityName, startTime, new Date(), activityJsonData, activityParam1, activityParam2, url, null);
};

export const logAPI = (activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    return log("WEB_API", activityName, startTime, url, activityJsonData, activityParam1, activityParam2);
}

export const logUI = (activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    return log("WEB_UI", activityName, startTime, url, activityJsonData, activityParam1, activityParam2);
}


export const logToAndylitics = (activityName, startTime, url) => {
    logAndylitics("WEB_API", activityName, startTime, new Date(), null, null, null, url, null);
};
